import { SearchPickerOption } from '@trustoo/components/searchPicker/SearchPickerContext'
import { GeoIdLocation } from '@trustoo/types/api/controllers/geo'

/**
 * Maps a raw geo `LocationData` result onto a `SearchPickerOption`. The full result is kept on
 * `data` so consumers receive the complete `LocationData` (place_name, postal_code, url_name, …)
 * when an option is selected.
 */
export const mapLocationDataToOption = (result: GeoIdLocation): SearchPickerOption => ({
    id: result.postal_code_id,
    content: result.place_name,
    query: result.place_name,
    data: result,
})
